function setCookie(cname, cvalue, exdays) {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = `expires=${d.toUTCString()}`
  document.cookie = `${cname}=${cvalue};${expires};path=/`
}

function getCookie(cname) {
  const name = `${cname}=`
  const ca = document.cookie.split(';')
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

const animateInScrool = (items, treshold = 0.2) => {
  function callback(entries) {
    entries.forEach((entry, key) => {
      const animateItem = entry.target
      if (entry.isIntersecting && entry.intersectionRatio >= treshold) {
        setTimeout(() => {
          animateItem.classList.add('loaded')
        }, (key % 6) * 300)
        // observer.unobserve(entry.target)
      } else if (entry.boundingClientRect.y > 0) {
        animateItem.classList.remove('loaded')
      }
    })
  }

  const intersectionObserver = new IntersectionObserver(callback, {
    threshold: treshold,
  })

  // eslint-disable-next-line no-restricted-syntax
  for (const i in items) {
    // eslint-disable-next-line no-prototype-builtins
    if (!items.hasOwnProperty(i)) {
      // eslint-disable-next-line no-continue
      continue
    }
    intersectionObserver.observe(items[i])
  }
}

function getQuantityType(count) {
  // eslint-disable-next-line no-nested-ternary
  const returnVal = count === 1 ? 0 : count > 10 && count < 21 ? 2 : null
  if (returnVal !== null) {
    return returnVal
  }

  const lastDigit = Number(`${count}`.slice(-1))

  return (lastDigit >= 0 && lastDigit <= 1) ||
    (lastDigit >= 5 && lastDigit <= 9)
    ? 2
    : 1
}

const lazyImgInScrool = (items, treshold = 0) => {
  function callback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.intersectionRatio >= treshold) {
        const animateItem = entry.target
        let status = true
        if (animateItem.dataset.minsize) {
          const media = window.matchMedia(
            `(min-width: ${animateItem.dataset.minsize})`
          )
          if (!media.matches) {
            status = false
          }
        }
        if (status) {
          const img = animateItem.dataset.src
          animateItem.src = img
          delete animateItem.dataset.src
          observer.unobserve(entry.target)
        }
      }
    })
  }

  const intersectionObserver = new IntersectionObserver(callback, {
    threshold: treshold,
  })

  // eslint-disable-next-line no-restricted-syntax
  for (const i in items) {
    // eslint-disable-next-line no-prototype-builtins
    if (!items.hasOwnProperty(i)) {
      // eslint-disable-next-line no-continue
      continue
    }
    intersectionObserver.observe(items[i])
  }
}

function hasSomeParentTheClass(element, classname, classstop = 'body-wrap') {
  if (element.classList.contains(classstop)) return false
  if (element.classList.contains(classname)) return true
  return (
    element.parentNode && hasSomeParentTheClass(element.parentNode, classname)
  )
}

function getSomeParentTheClass(element, classname) {
  if (element.classList.contains('body-wrap')) return false
  if (element.classList.contains(classname)) {
    return element
  }
  return getSomeParentTheClass(element.parentNode, classname)
}

const dataFetch = async (
  url,
  data = {},
  method = 'POST',
  header = {},
  responseType = 'json'
) => {
  document.body.classList.add('wait')
  const config = {
    method,
  }
  if (data) {
    config.body = data
  }
  if (header) {
    config.headers = header
  }

  const response = await fetch(url, {
    ...config,
    method,
  }).then((res) => {
    document.body.classList.remove('wait')
    if (responseType === 'text') {
      return res.text()
    }
    return res.json()
  })

  return response
}

export {
  setCookie,
  getCookie,
  animateInScrool,
  getQuantityType,
  lazyImgInScrool,
  hasSomeParentTheClass,
  getSomeParentTheClass,
  dataFetch,
}
